// theme for MUI controls
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00A8CD', // Replace with your desired color,
      contrastText: '#fff', // This makes button text white
    },
    error: {
      main: '#D74452', // Replace with your desired error color}
    }
  },
});

export default theme;